import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import { CONTENT } from "@/lib/content";
import { fetchPage } from "@/lib/apiData";

export default function ContentPage({ slug }) {
  const { data: page } = useQuery({ queryKey: ["page", slug], queryFn: () => fetchPage(slug), retry: false });
  const fallback = CONTENT[slug];

  const title = page?.title || fallback?.title || "Page";
  const label = fallback?.label || "Jollanda";

  return (
    <div data-testid={`content-${slug}`} className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-neutral-500 hover:text-[#d00000] transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" /> Back home
        </Link>
        <p className="text-xs uppercase tracking-[0.25em] text-[#d00000] mb-3">{label}</p>
        <h1 className="font-display text-5xl font-black tracking-tighter text-neutral-900">{title}</h1>
      </motion.div>

      <div className="mt-10">
        {page?.body ? (
          <p className="text-lg text-neutral-700 leading-relaxed whitespace-pre-line">{page.body}</p>
        ) : (
          <div className="space-y-10">
            {(fallback?.sections || []).map((s, i) => (
              <div key={i} className="border-l-2 border-[#d00000] pl-6">
                <h2 className="font-display text-2xl font-bold text-neutral-900">{s.h}</h2>
                <p className="mt-2 text-neutral-600 leading-relaxed">{s.p}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mt-16 border border-neutral-200 bg-white p-6">
        <p className="text-neutral-600 text-sm">Still have questions? Reach us at <a href="mailto:customersupport@jollanda.com" className="text-[#d00000] hover:underline">customersupport@jollanda.com</a> or call <a href="tel:0685973458" className="text-[#d00000] hover:underline">0685973458</a>.</p>
      </div>
    </div>
  );
}
